import { useEffect, useLayoutEffect } from "react";

// measuring before paint is the point, but useLayoutEffect warns when the
// calling component is server-rendered
const useIsomorphicLayoutEffect =
  typeof window === "undefined" ? useEffect : useLayoutEffect;

export default useIsomorphicLayoutEffect;
